import { useSelector } from "react-redux"
import { RootState } from "./store"

export const useAuthToken = ()=>{
    return useSelector((state: RootState) => state.auth.token);
}